import React from 'react';
import LegalNav from '../components/LegalNav';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <LegalNav />
      
      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <p className="text-gray-400 mb-8">Last updated: March 2026</p>
        
        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Agreement to Terms</h2>
            <p>
              By accessing or using the LTV Production website (ltvproduction.com) and services, you 
              agree to be bound by these Terms of Service. If you do not agree to these terms, please 
              do not use our services.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Description of Services</h2>
            <p>
              LTV Production provides video-on-demand (VOD) streaming services, live streaming events, 
              and related content. We reserve the right to modify, suspend, or discontinue any part of 
              our services at any time.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. User Accounts</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You must be at least 13 years old to create an account.</li>
              <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
              <li>You are responsible for all activities that occur under your account.</li>
              <li>You must provide accurate and complete information when creating an account.</li>
              <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Content and Intellectual Property</h2>
            <p className="mb-4">
              All content on LTV Production, including videos, graphics, logos, and text, is owned by 
              us or our licensors and is protected by copyright and other intellectual property laws.
            </p>
            <p className="mb-4">You may not:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Copy, reproduce, distribute, or publicly display any content without permission</li>
              <li>Modify, create derivative works, or reverse engineer any content</li>
              <li>Use any content for commercial purposes without authorization</li>
              <li>Remove or alter any copyright or trademark notices</li>
              <li>Download, record, or capture streaming content</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Subscriptions and Payments</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Some services require a paid subscription or one-time purchase.</li>
              <li>Prices are subject to change with notice.</li>
              <li>Subscriptions automatically renew unless cancelled before the renewal date.</li>
              <li>Refunds are provided in accordance with our refund policy.</li>
              <li>You are responsible for any applicable taxes.</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Prohibited Conduct</h2>
            <p className="mb-4">You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use the services for any illegal purpose</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on the rights of others</li>
              <li>Transmit viruses, malware, or other harmful code</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt our services</li>
              <li>Use automated systems to access our services without permission</li>
              <li>Share your account with others or use another person's account</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">7. Live Events and Chat</h2>
            <p className="mb-4">When participating in live events and chat features:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>You must not post offensive, abusive, or inappropriate content</li>
              <li>You must respect other users and moderators</li>
              <li>We reserve the right to remove content and ban users who violate these rules</li>
              <li>We are not responsible for user-generated content in chats</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">8. Disclaimers</h2>
            <p className="mb-4">
              Our services are provided "as is" without warranties of any kind, either express or 
              implied. We do not guarantee that our services will be uninterrupted, error-free, or 
              secure.
            </p>
            <p>
              We are not responsible for any technical issues, including but not limited to streaming 
              quality, buffering, or service interruptions.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, LTV Production shall not be liable for any 
              indirect, incidental, special, consequential, or punitive damages arising from your 
              use of our services.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">10. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless LTV Production, its affiliates, and their 
              respective officers, directors, employees, and agents from any claims, damages, or 
              expenses arising from your use of our services or violation of these terms.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">11. Governing Law</h2>
            <p>
              These Terms of Service shall be governed by and construed in accordance with the laws 
              of the United Kingdom, without regard to its conflict of law provisions.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">12. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of 
              significant changes. Your continued use of our services after changes constitutes 
              acceptance of the new terms.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">13. Contact Us</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at:{' '}
              <a href="mailto:info@ltvproduction.com" className="text-purple-400 hover:underline">
                info@ltvproduction.com
              </a>
            </p>
          </section>
        </div>
      </div>
      
      {/* Footer */}
      <div className="border-t border-white/10 py-8">
        <div className="max-w-4xl mx-auto px-6 text-center text-gray-500 text-sm">
          © {new Date().getFullYear()} LTV Production. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
